import React, { useState, useEffect } from "react";
import { AuthLoadingScreen } from "../Shared/AuthLoadingScreen";

export const UserContext = React.createContext([{}, () => { }]);

export function UserContextProvider(props) {
	const [user, setUser] = useState({ isLoggedIn: false, isInitialized: false });

	async function triggerResetUserFromToken() {
		if (props.config.debugMode) {
			setUser({
				isLoggedIn: true,
				isInitialized: true,
				id: 1,
				firstName: "Developer",
				lastName: "User",
				canViewRecipe: true,
				canEditRecipe: true,
				canSendToKitchen: true,
				isUserAdmin: true,
				isVolumeToMassAdmin: true,
				isUnitAdmin: true,
				isUnitAppropriationAdmin: true,
				isMetricConversionAdmin: true,
				isTagAdmin: true
			});
			return;
		}

		try {
			const resp = await fetch(`${props.config.apiUrl}/Auth/Me`, { credentials: 'include' });
			if (resp.ok) {
				const data = await resp.json();
				setUser({
					isLoggedIn: true,
					isInitialized: true,
					appUserId: data.appUserId,
					username: data.username,
					firstName: data.firstName,
					lastName: data.lastName,
					canViewRecipe: data.canViewRecipe,
					canEditRecipe: data.canEditRecipe,
					canSendToKitchen: data.canSendToKitchen,
					isUserAdmin: data.isUserAdmin,
					isVolumeToMassAdmin: data.isVolumeToMassAdmin,
					isUnitAdmin: data.isUnitAdmin,
					isUnitAppropriationAdmin: data.isUnitAppropriationAdmin,
					isMetricConversionAdmin: data.isMetricConversionAdmin,
					isTagAdmin: data.isTagAdmin
				});
				return;
			}
		}
		catch { }

		// Default to logged out (but mark initialization complete so UI doesn't flash)
		setUser({ isLoggedIn: false, isInitialized: true });
	}

	useEffect(() => {
		triggerResetUserFromToken();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Don't render app until we've checked auth state to avoid flashes of unauthenticated UI
	if (!user.isInitialized) {
		return <AuthLoadingScreen />;
	}

	return (
		<UserContext.Provider value={[user, triggerResetUserFromToken]}>
			{props.children}
		</UserContext.Provider>
	);
}
